module.exports = __webpack_public_path__ + "assets/img/Load.76ab59c9.svg";